import React from 'react';
import Cover from '../components/Cover';
import ProjectSection from '../components/ProjectsSection';

function HomePage() {
  return (
    <>
      <Cover />
      <ProjectSection />
    </>
  );
}

export default HomePage;
